module.exports = __webpack_public_path__ + "dc2fb9befc0991f247021eb226d3875a.svg";